import React from 'react';
import { PARAM_NAMES } from "../../../../config";
import {capitalize} from "../../../../../../Utils";

const Head = ({params}) => {
    const th = params.map(param => <th>{PARAM_NAMES[param] || capitalize(param)}</th>)

    return (
        <thead>
            <tr>
                {th}
            </tr>
        </thead>
    )
}

export default Head;


// WEBPACK FOOTER //
// ./src/scenes/BidderWinRateConfig/components/FactorsTable/components/Head/index.js